import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Label, QuillInput, Select } from '@treams/treams-ui';

export default function ReviewGoalsInput(props: {
	submission: graphql.EvaluationSubmission;
	competencyLevelSet: graphql.CompetencyLevelSet;
	name: string;
	goal: graphql.EvaluationSubmissionGoal;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const [{ value }] = useField<graphql.EvaluationSubmissionItemReviewGoalInput[]>(props.name);

	const index = value && value.findIndex(({ goalID }) => goalID === props.goal.goal.id);
	const enabled = index >= 0;

	const options = props.competencyLevelSet.levels.map((level, index) => ({
		title: localize(level.title).text,
		value: index,
	}));

	return (
		<>
			{enabled && (
				<>
					<Box>
						<Label>{t('evaluation.submission.reviewGoals.scoreLabel')}</Label>
						<Box mt={2}>
							<Select.Formik
								search={false}
								placeholder={t('evaluation.submission.reviewGoals.scorePlaceholder')}
								name={`${props.name}.${index}.competency`}
								options={options}
							/>
						</Box>
					</Box>
					<Box mt={3}>
						<Label>{t('evaluation.submission.reviewGoals.explanationLabel')}</Label>
						<Box mt={2}>
							<QuillInput.Formik name={`${props.name}.${index}.text`} />
						</Box>
					</Box>
				</>
			)}
		</>
	);
}
